import { IconButton, Modal } from "@carbon6/c6-frontend-design";
import styles from "./DiscardEditsModal.module.css";

type DiscardEditsModalProps = {
  /** 머리글. 예) `창 닫기`. */
  heading: string;
  /** 무엇을 잃는지 말하는 문장. */
  message: string;
  /** 편집을 버리고 진행하는 버튼의 글. 예) `편집 버리고 닫기`. */
  confirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * 저장하지 않은 편집을 버리기 전에 묻는다. 창 닫기(`WindowStackHost`)와 상세 route 페이지 나가기가 같은 모양 · 버튼
 * 배치를 쓴다. 무엇을 잃는지는 콘텐츠가 아니라 호출부의 문장이 말한다.
 */
export function DiscardEditsModal({
  confirmText,
  heading,
  message,
  onCancel,
  onConfirm,
}: DiscardEditsModalProps) {
  return (
    <Modal open size="sm" onClose={onCancel}>
      <Modal.Header>
        <Modal.Header.Start>
          <Modal.Header.Title>{heading}</Modal.Header.Title>
        </Modal.Header.Start>
        <Modal.Header.End>
          <Modal.Header.Close label="닫기" />
        </Modal.Header.End>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.message}>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.actions}>
          <IconButton
            text="취소"
            tone="neutral"
            type="button"
            variant="surface"
            onClick={onCancel}
          />
          <IconButton
            text={confirmText}
            tone="danger"
            type="button"
            variant="solid"
            onClick={onConfirm}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}
